var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CommonHeader',{attrs:{"breadcrumbs":_vm.breadcrumbs,"navigate-func":_vm.navigateToBreadcrumb}})
}
var staticRenderFns = []

export { render, staticRenderFns }